export const environment = {
  production: true,
  apiUrl: 'https://api-voyage.grooupee.fr',
  apiEdgeUrl: 'https://{index}-edge.api-voyage.grooupee.fr',
};
